import {mapRunningTimes} from '@domain/shared'
import {
  EquipmentRunningTimes,
  EquipmentRunningTimesDto,
  PlantRunningTimesDto
} from '@hconnect/common/types'

export const selectEquipmentRunningTimes =
  (timezone: string) =>
  (data: PlantRunningTimesDto[]): EquipmentRunningTimes[] =>
    data
      .flatMap(({equipmentsWithRunningTimes}) => equipmentsWithRunningTimes)
      .map((item) => ({
        ...item,
        runningTimes: mapRunningTimes(item.runningTimes, timezone)
      }))

export const selectSinglePlantEquipment = (
  data: PlantRunningTimesDto[]
): EquipmentRunningTimesDto[] => data[0]?.equipmentsWithRunningTimes ?? []
